var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportingAnalytical = function SvgReportingAnalytical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "reporting_analytical_svg2__a",
    x1: 18.21,
    x2: 157.61,
    y1: 175.79,
    y2: 17.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#reporting_analytical_svg2__a",
    id: "reporting_analytical_svg2__c",
    x1: 36.62,
    x2: 176.03,
    y1: 192.04,
    y2: 34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#reporting_analytical_svg2__a",
    id: "reporting_analytical_svg2__d",
    x1: 71.57,
    x2: 210.98,
    y1: 222.87,
    y2: 64.83
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#reporting_analytical_svg2__a",
    id: "reporting_analytical_svg2__e",
    x1: 94.95,
    x2: 234.36,
    y1: 243.49,
    y2: 85.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#reporting_analytical_svg2__a",
    id: "reporting_analytical_svg2__f",
    x1: 3.57,
    x2: 142.98,
    y1: 162.88,
    y2: 4.84
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M30.01 143.34h-20c-5.52 0-9.99 4.48-10 10v43.33c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33v-43.33c0-5.52-4.48-9.99-10-10Zm3.33 49.99H6.68v-39.99c0-1.84 1.49-3.33 3.33-3.33h20c1.84 0 3.33 1.49 3.33 3.33z",
    style: {
      fill: "url(#reporting_analytical_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33 96.68h-20c-5.52 0-9.99 4.48-10 10v89.99c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33v-89.99c0-5.52-4.48-9.99-10-10Zm3.34 96.65H60.01v-86.65c0-1.84 1.49-3.33 3.33-3.33h20c1.84 0 3.33 1.49 3.33 3.33z",
    style: {
      fill: "url(#reporting_analytical_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.66 116.68h-20c-5.52 0-9.99 4.48-10 10v69.99c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33v-69.99c0-5.52-4.48-9.99-10-10Zm3.33 76.65h-26.66v-66.66c0-1.84 1.49-3.33 3.33-3.33h20c1.84 0 3.33 1.49 3.33 3.33z",
    style: {
      fill: "url(#reporting_analytical_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.99 90.02h-20c-5.52 0-9.99 4.48-10 10v96.65c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33v-96.65c0-5.52-4.48-9.99-10-10Zm3.33 103.31h-26.66v-93.32c0-1.84 1.49-3.33 3.33-3.33h20c1.84 0 3.33 1.49 3.33 3.33z",
    style: {
      fill: "url(#reporting_analytical_svg2__e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.06 39.95a19.99 19.99 0 0 0 24.25 4.41 19.97 19.97 0 0 0 10.09-22.48c-2.21-8.92-10.22-15.19-19.41-15.18a19.987 19.987 0 0 0-18.48 27.62l-19.92 12.45a19.9 19.9 0 0 0-14.08-6.72 19.93 19.93 0 0 0-14.6 5.5L91.1 29.19c4.61-8.92 1.89-19.88-6.36-25.61S65.27-.87 58.53 6.57c-6.75 7.44-6.93 18.73-.43 26.38L30.16 66.16c-8.96-5.27-20.46-2.8-26.47 5.69-6 8.49-4.5 20.16 3.45 26.85 7.96 6.69 19.71 6.17 27.05-1.2 7.33-7.37 7.8-19.13 1.07-27.05L63.2 37.24c7.67 4.56 17.45 3.45 23.89-2.73l21.81 16.36c-4.25 8.22-2.29 18.29 4.72 24.32 7.01 6.04 17.26 6.47 24.76 1.05s10.3-15.28 6.76-23.84zm14.93-26.59c7.36 0 13.33 5.97 13.33 13.33s-5.97 13.32-13.33 13.33c-7.36 0-13.33-5.97-13.33-13.33s5.97-13.33 13.33-13.33M20.01 96.68c-7.36 0-13.33-5.97-13.33-13.33s5.97-13.33 13.33-13.33 13.33 5.97 13.33 13.33-5.97 13.32-13.33 13.33m53.33-63.32c-7.36 0-13.33-5.97-13.33-13.33S65.98 6.7 73.34 6.7s13.33 5.97 13.33 13.33-5.97 13.32-13.33 13.33m53.32 39.99c-7.36 0-13.33-5.97-13.33-13.33s5.97-13.33 13.33-13.33 13.33 5.97 13.33 13.33-5.97 13.32-13.33 13.33",
    style: {
      fill: "url(#reporting_analytical_svg2__f)",
      strokeWidth: 0
    }
  }));
};
export default SvgReportingAnalytical;